import Vue from "vue";
import Router from "vue-router";
import Home from "../components/Home";
import ContactList from "../components/Contacts/ContactList.vue";
import CreateContact from "../components/Contacts/CreateContact";
import Contact from "../components/Contacts/Contact";
import Signup from "../components/User/Signup";
import Signin from "../components/User/Signin";
import AuthGuard from "./auth-guard";
import Profile from '../components/User/Profile'
import Hotel from '../components/Hotels/Hotel.vue'
import HotelList from '../components/Hotels/HotelList'
import CreateHotel from '../components/Hotels/CreateHotel'

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/ContactList",
      name: "ContactList",
      component: ContactList,
      beforeEnter: AuthGuard
    },
    {
      path: "/HotelList",
      name: "HotelList",
      component: HotelList,
      beforeEnter: AuthGuard
    },
    {
      path: "/ContactList/new",
      name: "CreateContact",
      component: CreateContact,
      beforeEnter: AuthGuard
    },
    {
      path: "/HotelList/new",
      name: "CreateHotel",
      component: CreateHotel,
      beforeEnter: AuthGuard
    },
    {
      path: "/Contact/:id",
      name: "Contact",
      props: true,
      component: Contact
    },
    {
      path: "/Hotel/:id",
      name: "Hotel",
      props: true,
      component: Hotel
    },
    {
      path: "/User/Profile",
      name: "Profile",
      component: Profile,
      beforeEnter: AuthGuard
    },
    {
      path: "/Signup",
      name: "Signup",
      component: Signup
    },
    {
      path: "/Signin",
      name: "Signin",
      component: Signin
    }
  ]
});
